/**
 * Plan Service
 * Handles API calls for plan and month_plan operations
 * Task 002 - Plans Management
 */

import { Plan, PlanWithStats, CreatePlanData, UpdatePlanData, MonthPlan, CreateMonthPlanData } from '../types/plan';
import apiClient from '../lib/apiClient';

/**
 * Create a new plan (auto-creates first month_plan)
 */
export const createPlan = async (data: CreatePlanData): Promise<Plan> => {
  return apiClient.post('/plans', data);
};

/**
 * Get all plans for current user
 */
export const getUserPlans = async (): Promise<PlanWithStats[]> => {
  return apiClient.get('/plans');
};

/**
 * Get specific plan by ID
 */
export const getPlanById = async (planId: string): Promise<Plan> => {
  return apiClient.get(`/plans/${planId}`);
};

/**
 * Update plan name
 */
export const updatePlan = async (planId: string, data: UpdatePlanData): Promise<Plan> => {
  return apiClient.put(`/plans/${planId}`, data);
};

/**
 * Delete plan (cascade deletes all month_plans and related data)
 */
export const deletePlan = async (planId: string): Promise<void> => {
  return apiClient.delete(`/plans/${planId}`);
};

/**
 * Get all month_plans for a plan
 */
export const getMonthPlans = async (planId: string): Promise<MonthPlan[]> => {
  return apiClient.get(`/plans/${planId}/month-plans`);
};

/**
 * Manually create month_plan with gap filling
 */
export const createMonthPlan = async (
  planId: string,
  data: CreateMonthPlanData
): Promise<MonthPlan[]> => {
  return apiClient.post(`/plans/${planId}/month-plans`, data);
};

/**
 * Get or auto-create current month_plan
 */
export const getCurrentMonthPlan = async (planId: string): Promise<MonthPlan> => {
  return apiClient.get(`/plans/${planId}/month-plans/current`);
};

/**
 * Task 002b: Check and auto-create next month if missing
 * Should be called when user accesses the budget page
 */
export const checkAndCreateNextMonth = async (planId: string): Promise<{ status: string; message: string }> => {
  return apiClient.post(`/plans/${planId}/month-plans/check-next`);
};
